export default "__VITE_ASSET__$07uS6WG__"